import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentsListComponent } from './payments-list.component';
import { CtButtonModule, CtModelModule } from '@ctsolution/ct-framework';
import { PaymentsEditModule } from '../payments-edit/payments-edit.module';
import { PaymentsService } from '../payments.service';

@NgModule({
  imports: [
    CommonModule,
    CtModelModule,
    CtButtonModule,
    // PaymentsEditModule è necessario per la dichiarazione di PaymentsEditComponent
    // aperto come dialog da PaymentsService.openForm() (CtA "Crea" della datatable).
    PaymentsEditModule
  ],
  declarations: [PaymentsListComponent],
  exports : [PaymentsListComponent],
  // PaymentsService non era registrato in alcun providers: lo dichiariamo qui a livello
  // di modulo lista, dato che è il chiamante dell'openForm() per la creazione.
  providers: [PaymentsService]
})
export class PaymentsListModule { }
